import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/services/storage/storage.service';
import { RouterClass } from 'src/app/services/utils/router/router-class.routes';
import { errorMessages } from 'src/app/services/utils/snackbar/messages/error-messages';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class SelectClinicGuard implements CanActivate {

  constructor(
    private storageService: StorageService,
    private snackbarService: SnackbarService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.storageService.clinic) return true
    this.router.navigate(RouterClass.routerLinks.SELECT_CLINIC)
    this.snackbarService.showError(errorMessages.clinic_not_selected)
  }
}
